import { ServicesContainer } from '@/services';
import { ErrorEvent } from '@/services/analytics/events';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeErrorEvent } from './adobe-error';
import { MaxEntreeErrorEvent } from '@/services/analytics/events/max-byoc-error-event';
import { OrderErrorCode } from '@/models';
import { Routes } from '@/router';

// Hardcoding the error messages because the errorData property returned from COP is inconsistent. 
const maxOneByocInBagMessage = 'You can have only one Build Your Own meal in your bag.';
const maxMealsInBagMessage = 'You can only add one Build Your Own meal and 9 entrees, or up to 15 entrees to your bag. Need to feed a bigger crew?';
export class AdobeMaxEntreeErrorEvent extends AdobeErrorEvent {
  constructor(event: MaxEntreeErrorEvent, store: Store<AppState>, services: ServicesContainer) {
    let errorMessage = event.error.errorCode === OrderErrorCode.MaxBYOLimitExceeded ? maxOneByocInBagMessage : maxMealsInBagMessage;
    super({ errorType: 'checkout', errorName: errorMessage, action: 'add to bag' } as ErrorEvent, store, services);

    this.error = this.extendObject(this.error, { errorMessage });

    if (this.web.webInteraction) {
      this.web.webInteraction.linkTitle = event.pceName;
      this.web.webInteraction.name = 'add to cart';
      delete this.web.webInteraction.linkModuleName; // not relevant for this event
    }

    this.error.errorCode = `${event.error.errorCode}|${event.error.errorDescription}`;
  }

  getPagePrefix(routeName: string): string {
    switch(routeName) {
      case Routes.MealBuilder:
      case Routes.PcmMealBuilderEdit:
        return 'order:meal-builder';
      case Routes.Home:
        return 'home:order';
      case 'cart':
        return 'order:cart';
      case Routes.RecentsAndFavorites:
        return 'account:favorites-recents';
      default:
        return '';
    }
  }
}